import { LinkProps } from "next/link"
import { useMemo, useCallback } from "react"

import SquareButton from "~/components/atoms/SquareButton"

type PaginationLinkProps = {
  href?: LinkProps["href"]
  baseUrl: string
  queryStrings?: string
  page: number
  isCurrent?: boolean
  disabled?: boolean
  icon?: JSX.Element
  onPageCountClick?: (pageCount: number) => void
}

export const PaginationLink = (_props: PaginationLinkProps) => {
  const { href, baseUrl, queryStrings, page, icon, onPageCountClick, ...props } = _props

  const query = useMemo(() => {
    if (queryStrings) {
      return `${queryStrings}&page=${page}`
    }
    return `?page=${page}`
  }, [page, queryStrings])

  const onClick =
    onPageCountClick !== undefined
      ? useCallback(() => onPageCountClick && onPageCountClick(page), [onPageCountClick, page])
      : undefined

  return (
    <SquareButton {...props} size="Small" href={href || `${baseUrl}${query}`} onClick={onClick}>
      {icon || <span>{page}</span>}
    </SquareButton>
  )
}
